import { render, staticRenderFns } from "./BrainstormMatrix.vue?vue&type=template&id=09cc5b6a&scoped=true&"
import script from "./BrainstormMatrix.vue?vue&type=script&lang=js&"
export * from "./BrainstormMatrix.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormMatrix.vue?vue&type=style&index=0&id=09cc5b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc5b6a",
  null
  
)

export default component.exports